export const MenuRoutes = [
    {
        title:'Home',
        path:'/'
    }, {
        title:'Market(ERC721)',
        path:'/collectionsv2'
    }, 
    {
        title:'Ecosystem',
        path:'/ecosystem',
        elements:[
            // {title:'ZenoPASS',path:'/membershipspagev2'}, 
            {title:'ZenoBundle (ERC1155)',path:'https://zenonexus.pages.dev/#/collectionsv2', outLink:true},
            {title:'More...',path:'/comming'} 
        ]
    }, 
    {
        title:'Studio',
        path:'/studio',
        elements:[
            {title:'ZenoPASS',path:'/membershipspagev2'},
            {title:'My ZenoList',path:'/mywhitelistspagev2'},
            {title:'Create Collection',path:'/createcolletionv2'},
            {title:'Create NFT',path:'/createnftv2'}, 
        ]
    }, 
    {
        title:'About Us',
        path:'https://zenolabs.pages.dev'
    }
]
